import React, { useEffect, useRef, useState } from 'react';
import PatientDevicesTab from '~/components/patientReports/PatientDevicesTab';
import { Grid, Menu, MenuItem, Tabs } from '@mui/material';
import { DownloadOutlined, PrintOutlined, SyncOutlined, } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { fetchPatientData } from '~/api/patient/fetchPatientData';
import { format } from 'date-fns';
import { FaSpinner } from 'react-icons/fa';
import axios from 'axios';
import { SyncProgressLayout } from "~/components/patientReports/SyncProgressLayout";
import { RouteLoader } from "~/components/loaders";
import TrendsTab from "~/components/patientReports/TrendsTab";
import CarePlanTab from "~/components/carePlan/CarePlanTab";
const PatientDevicesPane = ({ patient, patientId, pdfPath, cgmUrl, patientArray, patientReportArray, tabSelected, trendsSelected, carePlanSelected, initialPrimaryPatient, onDownloadPDF, carePlanInitial }) => {
    const [printing, setPrinting] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [creatingDataLog, setCreatingDataLog] = useState(false);
    const [fetchPatientId, setFetchPatientId] = useState(patientId);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const syncPatientRef = useRef(patientId); // default to initial
    const handlePrintCarePlanClick = () => {
        if (onDownloadPDF) {
            onDownloadPDF();
        }
        else {
            console.error('Download PDF function not available yet');
        }
    };
    useEffect(() => {
        const previouslySyncedStorageItem = sessionStorage.getItem('previously-synced-patient');
        if (previouslySyncedStorageItem) {
            const patientSyncData = JSON.parse(previouslySyncedStorageItem);
            setSelectedIndex(patientSyncData.index);
            sessionStorage.removeItem('previously-synced-patient');
        }
    }, []);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget.parentElement);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    console.log(cgmUrl);
    console.log('pdf path: ');
    console.log(pdfPath);
    const [totalReportLength, setTotalReportLength] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        let length = 0;
        patientArray.map((deviceName) => {
            length = length + deviceName.lastReport.length;
            setTotalReportLength(length);
        });
    });
    const handlePrint = () => {
        setPrinting(true);
        const iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.height = '0';
        iframe.style.width = '0';
        document.body.append(iframe);
        iframe.addEventListener('load', function () {
            // Safari is having issues with loading the PDF and presents an empty page
            window.setTimeout(() => {
                setPrinting(false);
                iframe.contentWindow?.focus();
                iframe.contentWindow?.print();
            }, 1000);
        });
        iframe.src = pdfPath;
    };
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const handleFetch = async () => {
        setFetching(true);
        sleep(250);
        // listenForProgress();
        if (syncPatientRef.current !== patientArray[0].id) {
            const syncPatientData = {
                patientId: fetchPatientId,
                index: selectedIndex
            };
            sessionStorage.setItem('previously-synced-patient', JSON.stringify(syncPatientData));
        }
        try {
            const { patient, reports } = await fetchPatientData({ patientId: fetchPatientId });
            console.log(patient);
            if (reports.length > 0) {
                const mostRecentReport = reports[0];
                const previouslySyncedStorageItem = sessionStorage.getItem('previously-synced-patient');
                if (previouslySyncedStorageItem) {
                    window.location.reload();
                }
                else {
                    navigate(`/report/${mostRecentReport.id}`);
                }
                // navigate(`/report/${mostRecentReport.id}`);
                // toast(message, {
                //   type: 'success',
                //   autoClose: false,
                //   containerId: toaster,
                //   onClick: () => {
                //     if (today === reportDate) {
                //       ;
                //     }
                //   },
                //
                // });
            }
            else {
                // toast.info(`Report data for ${patient.personalInfo.firstname} ${patient.personalInfo.lastname} updated. No new reports to show.`);
            }
        }
        catch (error) {
            // setFetching(false);
            console.error('error', error);
            // toast.info('Error retrieving patient report');
        }
    };
    // const [selectedDevice, setSelectedDevice] = useState(patientDevices[0]);
    const [selectedIndex, setSelectedIndex] = useState(carePlanInitial ? patientArray.length : 0);
    const handleSelectTab = (selectedPatient, report, index) => {
        // setSelectedDevice(patientDevices[index]);
        setSelectedIndex(index);
        tabSelected(selectedPatient, report);
        trendsSelected(false);
        console.log('selected tab');
        console.log(fetchPatientId);
        console.log('start patient');
        console.log(selectedPatient);
        console.log('end patient');
        console.log(selectedPatient.id);
        console.log(selectedPatient.id);
        setFetchPatientId(selectedPatient.id);
        trendsSelected(false);
        carePlanSelected(false);
    };
    const handleMakePrimary = async (primaryPatient) => {
        try {
            await axios.post('/api/patient/makePatientPrimary', {
                patient_id: primaryPatient.id
            });
            const previousStorageKey = `patient-timer-${initialPrimaryPatient.id}`;
            const newStorageKey = `patient-timer-${primaryPatient.id}`;
            const existingTimer = sessionStorage.getItem(previousStorageKey);
            if (existingTimer) {
                // Parse the existing timer data
                const timerData = JSON.parse(existingTimer);
                // Update the patientId in the timer data
                timerData.patientId = primaryPatient.id;
                // Store with new key
                sessionStorage.setItem(newStorageKey, JSON.stringify(timerData));
                sessionStorage.removeItem(previousStorageKey);
                const newTimer = sessionStorage.getItem(newStorageKey);
                console.log('new timer');
                console.log(newTimer);
            }
            alert('Primary patient updated');
            // Find the index of the selected patient
            const index = patientArray.findIndex(p => p.id === primaryPatient.id);
            // If there's a report at that same index, redirect to it
            const maybeReport = patientReportArray[index];
            if (maybeReport && maybeReport.id) {
                navigate(`/report/${maybeReport.id}`);
            }
            else {
                navigate(`/patient/${primaryPatient.id}`);
            }
        }
        catch (error) {
            console.error('error', error);
            toast.info('Error making patient primary');
        }
    };
    const handleSync = (syncPatient) => {
        syncPatientRef.current = syncPatient.id;
        setFetchPatientId(syncPatient.id);
        handleFetch();
    };
    const createDataLog = async () => {
        setCreatingDataLog(true);
        const toaster = toast.info('Creating daily data log.');
        try {
            const dateObj = new Date();
            const month = dateObj.getUTCMonth() + 1; // months from 1-12
            const day = dateObj.getUTCDate();
            const year = dateObj.getUTCFullYear();
            const newDate = year + "-" + month + "-" + day;
            const response = await axios.post('/api/patient/getDailyDataLogPdf/' + patientId + '/' + newDate);
            setCreatingDataLog(false);
            const link = document.createElement('a');
            document.body.append(link);
            link.href = response.data.data.reportPath;
            link.download = 'daily-data-log.pdf';
            link.click();
        }
        catch (error) {
            setCreatingDataLog(false);
            console.error('error', error);
            toast('Error creating patient daily data log', {
                type: 'error',
                autoClose: false,
                containerId: toaster,
            });
        }
    };
    const pdfFileName = format(new Date(), 'y-MM-d') + '_BloodSugars_' + patient.personalInfo.firstname + '_' + patient.personalInfo.lastname + '.pdf';
    const handleDownload = async () => {
        const response = await fetch(pdfPath);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = pdfFileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        handleClose();
    };
    return (React.createElement(React.Fragment, null,
        creatingDataLog && (React.createElement("div", { className: "fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 flex flex-col items-center justify-center", style: { backgroundColor: 'rgba(0, 0, 0, .4)' } },
            React.createElement(RouteLoader, null))),
        fetching && (React.createElement("div", { className: "fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 flex flex-col items-center justify-center", style: { backgroundColor: 'rgba(0, 0, 0, .4)' } },
            React.createElement(SyncProgressLayout, { tryAgainClicked: handleFetch, closeClicked: () => setFetching(false), patientId: syncPatientRef.current }))),
        React.createElement("div", { style: { borderBottom: '1px solid #ababab' } },
            React.createElement(Grid, { container: true, spacing: 2, className: 'relative', sx: { width: '100%' } },
                React.createElement(Grid, { item: true, xs: 9, sx: { minWidth: 0 } },
                    React.createElement(Tabs, { value: selectedIndex, onChange: () => console.log('changed'), variant: "scrollable", scrollButtons: "auto", allowScrollButtonsMobile: true, color: '#2C78EB', sx: { minHeight: '0px', height: '45px', '& .MuiTabs-scrollButtons.Mui-disabled': { opacity: 0.8 }, '.Mui-selected': {
                                color: '#2C78EB',
                            } } },
                        patientArray.map((deviceName, index) => React.createElement(PatientDevicesTab, { key: index, onClick: () => handleSelectTab(patientArray[index], patientReportArray[index], index), deviceName: patientArray[index].devicePortal.slug, isPrimary: patientArray[index].mergedPatients ? patientArray[index].mergedPatients.length > 0 : false, isArchived: patientArray[index]['isArchived'], tabValue: index, selectedIndex: selectedIndex, patient: patientArray[index], handleMakePrimaryCallback: (patient) => handleMakePrimary(patient), handleSyncCallback: (patient) => handleSync(patient) })),
                        React.createElement(CarePlanTab, { tabValue: patientArray.length, onClick: () => {
                                setSelectedIndex(patientArray.length);
                                carePlanSelected(true);
                                trendsSelected(false);
                            }, selectedIndex: selectedIndex, hasData: patient.ccmConsent || patient.rpmConsent }),
                        React.createElement(TrendsTab, { hasData: totalReportLength > 0, tabValue: patientArray.length + 1, onClick: () => { trendsSelected(true); carePlanSelected(false); setSelectedIndex(patientArray.length + 1); }, selectedIndex: selectedIndex }))),
                React.createElement(Grid, { item: true, xs: 3, style: { marginLeft: 'auto' } },
                    React.createElement(Grid, { container: true, spacing: 1, className: 'inline-flex h-full', alignItems: 'center' },
                        React.createElement(Grid, { item: true, xs: 1, className: 'h-full' },
                            React.createElement("div", { style: { borderRight: '1px solid #ababab', height: '82%', position: 'absolute', padding: '5px', overflow: 'hidden' } })),
                        React.createElement(Grid, { item: true, xs: 1 },
                            React.createElement("a", { style: { cursor: 'pointer' }, onClick: (event) => handleMenuClick(event) },
                                React.createElement(DownloadOutlined, null)),
                            React.createElement(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                                    'aria-labelledby': 'basic-button',
                                } },
                                React.createElement(MenuItem, null,
                                    React.createElement("a", { onClick: handleDownload }, "Device Report")),
                                React.createElement(MenuItem, null,
                                    React.createElement("a", { onClick: () => { createDataLog(); handleClose(); } }, "Data Log")),
                                React.createElement(MenuItem, null,
                                    React.createElement("a", { onClick: handlePrintCarePlanClick }, "Care Plan")))),
                        React.createElement(Grid, { item: true, xs: 1, className: 'h-0.5' },
                            React.createElement("div", { style: { borderRight: '1px solid #ababab', height: '50%', padding: '5px' } })),
                        React.createElement(Grid, { item: true, xs: 1 },
                            React.createElement("button", { onClick: handlePrint, disabled: printing },
                                React.createElement(PrintOutlined, null))),
                        React.createElement(Grid, { item: true, xs: 1, className: 'h-0.5' },
                            React.createElement("div", { style: { borderRight: '1px solid #ababab', height: '50%', padding: '5px' } })),
                        React.createElement(Grid, { item: true, xs: 1 }, fetching ? (React.createElement(React.Fragment, null,
                            React.createElement(FaSpinner, { className: "spin" }))) : (React.createElement(React.Fragment, null,
                            React.createElement(Button, { size: "small", color: "secondary", variant: "contained", startIcon: React.createElement(SyncOutlined, null), style: { background: '#018FB7' }, onClick: handleFetch, disabled: fetching }, "Sync"))))))),
            React.createElement("div", null))));
};
export default PatientDevicesPane;
